import { createAsyncThunk } from '@reduxjs/toolkit';
import { shopService, workerService, siteService } from 'services';

import * as Types from 'types';

export const getWorkerStatus = createAsyncThunk<
  Types.GetWorkerStatusResponse,
  Types.GetWorkerStatusRequest,
  Types.ThunkAPI<Types.GetWorkerStatusError>
>('workerStatus/thunk/getWorkerStatus', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getWorkerStatus(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getWorkRisk = createAsyncThunk<
  Types.GetWorkRiskResponse,
  Types.GetWorkRiskRequest,
  Types.ThunkAPI<Types.GetWorkRiskError>
>('workRisk/thunk/getWorkRisk', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getWorkRisk(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getWorkerInfoChange = createAsyncThunk<
  Types.GetWorkersChargeSiteResponse,
  Types.GetWorkersChargeSiteRequest,
  Types.ThunkAPI<Types.GetWorkersChargeSiteError>
>('workRisk/thunk/getWorker', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getWorkerChangeSite(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getWorkerInfoChangeSchedules = createAsyncThunk<
  Types.GetSiteUserResponse,
  Types.GetSiteUserRequest,
  Types.ThunkAPI<Types.GetSiteUserError>
>('workRisk/thunk/change', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getWorkerSchedules(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getCheckSlingTool = createAsyncThunk<
  Types.GetCheckSlingToolResponse,
  Types.GetCheckSlingToolRequest,
  Types.ThunkAPI<Types.GetCheckSlingToolError>
>('checkSlingTool/Thunk/getCheckSlingTool', async (params, { rejectWithValue }) => {
  try {
    const { data } = await shopService.getCheckSlingTool(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getListTestScaffold = createAsyncThunk<
  Types.GetTestScaffoldResponse,
  Types.GetTestScaffoldRequest,
  Types.ThunkAPI<Types.GetTestScaffoldError>
>('testScaffold/Thunk/getTestScaffold', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getListTestScaffold(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getSafetyInstructions = createAsyncThunk<
  Types.GetSafetyInstructionsResponse,
  Types.GetSafetyInstructionsRequest,
  Types.ThunkAPI<Types.GetSafetyInstructionsError>
>('safetyInstructions/Thunk/getSafetyInstructions', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getSafetyInstructions(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getWorkerShift = createAsyncThunk<
  Types.GetWorkerResponse,
  Types.GetWorkerRequest,
  Types.ThunkAPI<Types.GetWorkerError>
>('tableGantt/thunk/getWorkerShift', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getWorkerShift(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const postStamp = createAsyncThunk<
  Types.PostStampResponse,
  Types.PostStampRequest,
  Types.ThunkAPI<Types.PostStampResponse>
>('post/stamp/modify', async (paramsData, { rejectWithValue }) => {
  try {
    const { data } = await workerService.postStamp(paramsData);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getShopSchedulesWorkersChargeSiteList = createAsyncThunk<
  Types.getShopSchedulesWorkersChargeSiteListResponse,
  Types.getShopSchedulesWorkersChargeSiteListParams,
  Types.ThunkAPI<Types.getShopSchedulesWorkersChargeSiteListError>
>('/cooperators/schedules/workers_charge_site_list', async (params, { rejectWithValue }) => {
  try {
    const { data } = await shopService.getShopSchedulesWorkersChargeSiteList(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getCooperatorUser = createAsyncThunk<
  Types.GetCooperatorResponse,
  Types.GetCooperatorRequest,
  Types.ThunkAPI<Types.GetCooperatorError>
>('/cooperator/user', async (params, { rejectWithValue }) => {
  try {
    const { data } = await shopService.getCooperatorUser(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getSiteUserSchedules = createAsyncThunk<
  Types.GetSiteUserSchedulesResponse,
  Types.GetSiteUserSchedulesRequest,
  Types.ThunkAPI<Types.GetSiteUserSchedulesError>
>('/site/user/schedules', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getSiteUserSchedules(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
export const getSiteGroupsWorkers = createAsyncThunk<
  Types.GetSiteGroupsWorkersRsponse,
  Types.GetSiteGroupsWorkersRequest,
  Types.ThunkAPI<Types.GetSiteGroupsWorkersError>
>('/site/user/getSiteGroupsWorkers', async (params, { rejectWithValue }) => {
  try {
    const { data } = await shopService.getSiteGroupsWorkers(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
